/* Belly&Moi — Module « Trouver ma taille » (snippet bm-size-finder). Aucune bibliothèque : <dialog> natif.
   - Grille lue dans <script data-bm-sf-grid> (Paramètres du thème → Belly&Moi – Guide des tailles). Aucune valeur inventée ici.
   - Ordre de calcul : tour de hanches, puis tour de taille, puis poids. La hauteur sert seulement à vérifier la saisie.
   - Entre deux tailles (chevauchement ou trou entre deux fourchettes) : taille au-dessus.
   - Au-delà de la plus grande taille : aucune taille forcée, on invite à nous contacter.
   - « Choisir la taille X » : règle la taille de toutes les lignes de l'offre active du sélecteur (bm-bundle-selector.js
     réagit à l'événement « change » des pilules, on ne le modifie pas).
   - Deux onglets : « Trouver ma taille » (calculateur) et « Tableau des tailles » (rendu en Liquid depuis la grille ;
     la ligne conseillée y est surlignée après un calcul). Le lien « Voir le tableau des tailles » ouvre directement le 2e. */
(function () {
  var LIMITS = {
    height: { min: 140, max: 200, message: 'Indiquez une taille entre 140 et 200 cm.' },
    weight: { min: 40, max: 150, message: 'Indiquez un poids entre 40 et 150 kg.' },
    waist: { min: 50, max: 200, message: 'Indiquez un tour de taille entre 50 et 200 cm.' },
    hips: { min: 50, max: 200, message: 'Indiquez un tour de hanches entre 50 et 200 cm.' },
  };
  var LABELS = {
    hips: { unit: 'cm', text: 'de tour de hanches' },
    waist: { unit: 'cm', text: 'de tour de taille' },
    weight: { unit: 'kg', text: '' },
  };
  var BETWEEN = 'Vous êtes entre deux tailles : nous vous conseillons la taille au-dessus pour plus de confort.';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function formatNumber(value) {
    return String(value).replace('.', ',');
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Taille d'une colonne (hips, waist ou weight) pour une valeur. Retourne null si la colonne est vide.
  function lookup(rows, column, value) {
    var ranges = rows
      .filter(function (row) {
        var pair = row[column];
        return pair && typeof pair[0] === 'number' && typeof pair[1] === 'number';
      })
      .map(function (row) {
        return { size: row.size, min: Math.min(row[column][0], row[column][1]), max: Math.max(row[column][0], row[column][1]) };
      });
    if (!ranges.length) return null;

    if (value < ranges[0].min) return { size: ranges[0].size, between: false };

    var matches = ranges.filter(function (r) {
      return value >= r.min && value <= r.max;
    });
    if (matches.length === 1) return { size: matches[0].size, between: false };
    if (matches.length > 1) return { size: matches[matches.length - 1].size, between: true };

    var last = ranges[ranges.length - 1];
    var maxAll = Math.max.apply(null, ranges.map(function (r) { return r.max; }));
    if (value > last.max && value > maxAll) return { over: true, max: maxAll, column: column };

    // Dans un trou entre deux fourchettes : la taille suivante.
    for (var i = 0; i < ranges.length; i++) {
      if (ranges[i].min > value) return { size: ranges[i].size, between: true };
    }
    return { over: true, max: maxAll, column: column };
  }

  function normalizeSize(value) {
    var v = String(value).trim().toUpperCase().replace(/\s+/g, '');
    if (v === '2XL') return 'XXL';
    if (v === 'XXXL') return '3XL';
    return v;
  }

  function init(root) {
    if (root.getAttribute('data-bm-sf-ready')) return;
    root.setAttribute('data-bm-sf-ready', '1');

    var dialog = root.querySelector('[data-bm-sf-dialog]');
    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-bm-sf-open]'));
    var opener = openers[0];
    var form = root.querySelector('[data-bm-sf-form]');
    var result = root.querySelector('[data-bm-sf-result]');
    var after = root.querySelector('[data-bm-sf-after]');
    var chart = root.querySelector('[data-bm-sf-chart]');
    var body = root.querySelector('[data-bm-sf-body]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bm-sf-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bm-sf-panel]'));
    var formError = root.querySelector('[data-bm-sf-form-error]');
    var tape = root.querySelector('[data-bm-sf-tape]');
    var tapeToggle = root.querySelector('[data-bm-sf-tape-toggle]');
    var title = dialog && dialog.querySelector('.bm-sf__title');
    var gridEl = root.querySelector('[data-bm-sf-grid]');
    if (!dialog || !opener || !form || !gridEl) return;

    var grid = JSON.parse(gridEl.textContent);
    var rows = grid.rows || [];
    var contactUrl = grid.contactUrl || '';
    var savedOverflow = '';

    function input(name) {
      return form.querySelector('[data-bm-sf-input="' + name + '"]');
    }

    function isVisible(el) {
      return !!el && !el.closest('[hidden]');
    }

    /* ----- Ouverture / fermeture ----- */
    function syncViewport() {
      // Clavier ouvert sur téléphone : la fenêtre reste au-dessus du clavier et dans la zone visible.
      var vv = window.visualViewport;
      if (!vv) return;
      var keyboard = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      dialog.style.setProperty('--bm-sf-max-height', vv.height + 'px');
      dialog.style.setProperty('--bm-sf-keyboard', keyboard + 'px');
    }

    /* ----- Onglets « Trouver ma taille » / « Tableau des tailles » ----- */
    function selectTab(name, moveFocus) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-bm-sf-tab') === name;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (on && moveFocus) tab.focus();
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-bm-sf-panel') !== name;
      });
      if (body) body.scrollTop = 0;
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        selectTab(tab.getAttribute('data-bm-sf-tab'), false);
      });
      // Clavier : flèches gauche/droite, Début, Fin.
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        selectTab(next.getAttribute('data-bm-sf-tab'), true);
      });
    });

    root.querySelectorAll('[data-bm-sf-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectTab(btn.getAttribute('data-bm-sf-goto'), true);
      });
    });

    function open(tabName) {
      if (tabs.length) selectTab(tabName || 'finder', false);
      savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      syncViewport();
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', syncViewport);
        window.visualViewport.addEventListener('scroll', syncViewport);
      }
      // Le titre reçoit le focus : il est lu par les lecteurs d'écran, et le clavier ne s'ouvre pas tout seul.
      if (title) title.focus();
    }

    function close() {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        onClosed();
      }
    }

    function onClosed() {
      document.documentElement.style.overflow = savedOverflow;
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', syncViewport);
        window.visualViewport.removeEventListener('scroll', syncViewport);
      }
      try {
        opener.focus({ preventScroll: true });
      } catch (e) {
        opener.focus();
      }
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        opener = btn; // le focus reviendra sur le lien utilisé
        open(btn.getAttribute('data-bm-sf-open'));
      });
    });
    dialog.addEventListener('close', onClosed);
    dialog.querySelectorAll('[data-bm-sf-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    // Clic sur le fond (en dehors du contenu) : le clic arrive directement sur <dialog>.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        // <dialog> ferme déjà avec Échap ; utile pour le repli sans showModal.
        if (!dialog.open || typeof dialog.showModal !== 'function') {
          event.preventDefault();
          close();
        }
        return;
      }
      if (event.key !== 'Tab') return;
      // Focus piégé : Tab et Maj+Tab bouclent dans la fenêtre.
      var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), isVisible);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (event.shiftKey && (active === first || active === title || !dialog.contains(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
        event.preventDefault();
        first.focus();
      }
    });

    // Champ touché avec le clavier ouvert : on le garde visible.
    form.addEventListener('focusin', function (event) {
      if (!event.target.matches('input')) return;
      window.setTimeout(function () {
        syncViewport();
        if (event.target.scrollIntoView) event.target.scrollIntoView({ block: 'center' });
      }, 300);
    });

    if (tapeToggle && tape) {
      tapeToggle.addEventListener('click', function () {
        var show = tape.hidden;
        tape.hidden = !show;
        tapeToggle.setAttribute('aria-expanded', show ? 'true' : 'false');
        if (show) {
          var firstField = tape.querySelector('input');
          if (firstField) firstField.focus();
        }
      });
    }

    /* ----- Validation ----- */
    function setFieldError(name, message) {
      var field = input(name);
      if (!field) return;
      var error = document.getElementById(field.getAttribute('aria-describedby'));
      field.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (error) {
        error.textContent = message || '';
        error.hidden = !message;
      }
    }

    function showFormError(message) {
      formError.textContent = message || '';
      formError.hidden = !message;
    }

    // Retourne { value, filled, error } pour un champ visible.
    function readField(name) {
      var field = input(name);
      if (!isVisible(field)) return { filled: false };
      var raw = field.value.trim().replace(',', '.');
      if (raw === '') return { filled: false };
      var value = Number(raw);
      var limit = LIMITS[name];
      if (!isFinite(value) || value < limit.min || value > limit.max) {
        return { filled: true, error: limit.message };
      }
      return { filled: true, value: value };
    }

    function validate() {
      var values = {};
      var errors = {};
      ['height', 'weight', 'waist', 'hips'].forEach(function (name) {
        var r = readField(name);
        if (r.error) errors[name] = r.error;
        else if (r.filled) values[name] = r.value;
      });

      var tapeFilled = values.waist !== undefined || values.hips !== undefined || errors.waist || errors.hips;
      var weightMode = isVisible(input('weight'));

      if (weightMode && !tapeFilled) {
        // Sans mesures au mètre ruban : taille et poids obligatoires.
        if (values.height === undefined && !errors.height) errors.height = LIMITS.height.message;
        if (values.weight === undefined && !errors.weight) errors.weight = LIMITS.weight.message;
      }

      ['height', 'weight', 'waist', 'hips'].forEach(function (name) {
        setFieldError(name, errors[name]);
      });

      if (!weightMode && !tapeFilled) {
        showFormError('Indiquez au moins votre tour de hanches ou votre tour de taille.');
        return null;
      }
      showFormError('');

      var firstError = Object.keys(errors)[0];
      if (firstError) {
        input(firstError).focus();
        return null;
      }
      return values;
    }

    /* ----- Résultat ----- */
    function compute(values) {
      var order = ['hips', 'waist', 'weight'];
      for (var i = 0; i < order.length; i++) {
        var column = order[i];
        if (values[column] === undefined) continue;
        var found = lookup(rows, column, values[column]);
        if (found) return found;
      }
      return null;
    }

    function contactLink(label) {
      return contactUrl ? '<a href="' + escapeHtml(contactUrl) + '">' + label + '</a>' : label;
    }

    function highlight(size) {
      chart.querySelectorAll('tr[data-size]').forEach(function (row) {
        row.classList.toggle('is-match', row.getAttribute('data-size') === size);
      });
    }

    function render(found) {
      var html = '';
      if (!found) {
        html =
          '<p class="bm-sf__result-title">Nous ne pouvons pas encore calculer avec ces mesures : ' +
          contactLink('contactez-nous') +
          '.</p>';
        highlight(null);
      } else if (found.over) {
        var label = LABELS[found.column];
        html =
          '<p class="bm-sf__result-title">Nos tailles vont jusqu\'à ' +
          formatNumber(found.max) +
          ' ' +
          label.unit +
          (label.text ? ' ' + label.text : '') +
          '. ' +
          contactLink('Contactez-nous') +
          ', nous vous conseillerons.</p>';
        highlight(null);
      } else {
        var size = escapeHtml(found.size);
        html =
          '<p class="bm-sf__result-title">Votre taille conseillée : <strong>' + size + '</strong></p>' +
          (found.between ? '<p class="bm-sf__note">' + BETWEEN + '</p>' : '') +
          '<button type="button" class="bm-sf__apply" data-bm-sf-apply data-size="' + size + '">Choisir la taille ' + size + '</button>';
        highlight(found.size);
      }
      result.innerHTML = html;
      // Lien vers l'onglet « Tableau des tailles » (ligne conseillée surlignée).
      if (after) after.hidden = false;
      var apply = result.querySelector('[data-bm-sf-apply]');
      if (apply) apply.addEventListener('click', function () {
        applySize(apply.getAttribute('data-size'));
      });
      if (result.scrollIntoView) {
        result.scrollIntoView({ block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var values = validate();
      if (!values) {
        result.innerHTML = '';
        if (after) after.hidden = true;
        return;
      }
      render(compute(values));
    });

    /* ----- Application au sélecteur d'offres ----- */
    function reducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setSelect(select, size) {
      var wanted = normalizeSize(size);
      for (var i = 0; i < select.options.length; i++) {
        if (normalizeSize(select.options[i].value) === wanted) {
          select.value = select.options[i].value;
          return true;
        }
      }
      return false;
    }

    function fire(select) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function applySize(size) {
      var selector = document.querySelector('[data-bundle-selector]');
      var offer = selector && (selector.querySelector('[data-offer].is-active') || selector.querySelector('[data-offer]'));
      if (offer) {
        var selects = Array.prototype.map.call(offer.querySelectorAll('[data-unit]'), function (unit) {
          return unit.querySelector('.bm-pill--size select');
        }).filter(Boolean);
        var same = offer.querySelector('[data-same-all]');
        if (selects.length) {
          if (same && same.checked) {
            // « Même choix pour toutes » coché : la ligne #1 est recopiée sur les autres par le sélecteur.
            if (setSelect(selects[0], size)) fire(selects[0]);
          } else {
            selects.forEach(function (select) {
              if (setSelect(select, size)) fire(select);
            });
          }
        }
      }
      close();
      if (offer && offer.scrollIntoView) {
        offer.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bm-size-finder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Éditeur de thème : la section est rechargée quand on modifie un réglage.
  document.addEventListener('shopify:section:load', initAll);
})();
